// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"797":"090b1323","827":"fff79366"}[chunkId] + ".chunk.js";
};